import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function CreateFlavourForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            size: "small",
            itemSize: { lg: 12, md: 12, sm: 12, xs: 12 },
          },
          {
            name: "price",
            label: "Price (Subscription)",
            type: "money",
            required: true,
            size: "small",
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
          },
          {
            name: "price_oneoff",
            label: "Price (One off order)",
            type: "money",
            required: true,
            size: "small",
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
          },
        ]}
        isLabel
        fullWidth={true}
        alignItems="flex-end"
        direction="row"
        spacing={2}
      />
    </div>
  );
});
